import * as yup from 'yup'
import { BRANCH_TIMEZONES } from '../../constants'

export const Schema = (branch = {}) => {
  const {
    pharmacy_name: name,
    telephone,
    address, postcode: legacyPostcode,
    address: { addressLine1, city: legacyCity, postcode, country } = {},
    primaryContact: { email = '', firstName = '', lastName = '' } = {},
    NACSCode, welcome_message, description, asid,
    gphc_number, gphc_url, city,
    timezone,
    external_data_mapping: { external_pharmacy_id } = {},
  } = branch;

  return {
    name: {
      'Name': { fieldName: 'addressLine1', defaultValue: name, field: 'pharmacy_name', validation: yup.string().required() },
    },
    address: {
      'Address Line 1': { fieldName: 'addressLine1', defaultValue: typeof address === 'string' ? address : addressLine1, field: 'address.addressLine1', validation: yup.string().required() },
      'City': { fieldName: 'city', defaultValue: city?.city || legacyCity, field: 'address.city', validation: yup.string().required(), disabled: Boolean(city) },
      'Postcode': { fieldName: 'postcode', defaultValue: postcode || legacyPostcode, field: 'address.postcode', validation: yup.string().required() },
      'Country': { fieldName: 'country', defaultValue: city?.country || country, field: 'address.country', validation: yup.string().required(), disabled: Boolean(city) },
      'County': { fieldName: 'county', defaultValue: city?.county || 'Unknown', field: 'address.county', disabled: true, placeholder: 'Unknown' }
    },
    pharmacyContact: {
      'First Name': { defaultValue: firstName, field: 'primaryContact.firstName', validation: yup.string().required() },
      'Last Name': { defaultValue: lastName, field: 'primaryContact.lastName', validation: yup.string().required() },
      'Email': { defaultValue: email, field: 'primaryContact.email', validation: yup.string().required() },
      'Telephone': { defaultValue: telephone, field: 'telephone', validation: yup.string().required() }
    },
    generalInfo: {
      'NACS Code': { fieldName: 'NACSCode', defaultValue: NACSCode, field: 'NACSCode', validation: yup.string().required() },
      'ASID Code': {
        fieldName: 'asid',
        defaultValue: asid,
        field: 'asid',
        validation: yup.string().required(),
      },
      'Description': { fieldName: 'description', defaultValue: description, field: 'description', validation: yup.string().required() },
      'Welcome Message': { fieldName: 'welcome_message', defaultValue: welcome_message, field: 'welcome_message', validation: yup.string().required() },
      'GPHC Registration Number': {
        fieldName: 'gphc_number',
        defaultValue: gphc_number,
        field: 'gphc_number',
        validation: yup.number().optional(),
      },
      'URL': {
        fieldName: 'gphc_url',
        defaultValue: gphc_url,
        field: 'gphc_url',
        validation: yup.string().optional(),
      },
      'Timezone': {
        fieldName: 'timezone',
        type: 'select',
        values: BRANCH_TIMEZONES,
        defaultValue: timezone,
        value: timezone,
        field: 'timezone',
        validation: yup.string().required(),
      },
      'External Pharmacy ID': {
        fieldName: 'external_pharmacy_id',
        defaultValue: external_pharmacy_id,
        field: 'external_data_mapping.external_pharmacy_id',
        validation: yup.string().optional(),
      },
    },
  }
}
